import cloneDeep from 'lodash.clonedeep';

import ScribeModel from 'js/models/ScribeModel';
import { ExistingScribeModel } from 'js/types';

export function cleanupUnusedAudioLayersAndIds(
  scribe: ExistingScribeModel | ScribeModel
): ExistingScribeModel | ScribeModel {
  const newActiveScribe = cloneDeep(scribe);
  // 1. Remove any layers that aren't being referenced by a scene or a project
  const audioLayerIdsInUse = new Set([
    ...(newActiveScribe.projectAudioLayerIds || []),
    ...newActiveScribe.scenes.flatMap(scene => scene.audioLayerIds || [])
  ]);
  newActiveScribe.audioLayers = newActiveScribe.audioLayers.filter(layer => audioLayerIdsInUse.has(layer.id));

  // 2. Remove any audio clips that aren't being referenced by any layer
  const audioClipIdsInUse = new Set(newActiveScribe.audioLayers.flatMap(layer => layer.audioClipIds || []));
  newActiveScribe.audioClips = (newActiveScribe.audioClips || []).filter(clip => audioClipIdsInUse.has(clip.id));

  // 3. Remove any clip ids from layers that are no longer in the audioClips array
  newActiveScribe.audioLayers.forEach(layer => {
    layer.audioClipIds = (layer.audioClipIds || []).filter(clipId =>
      (newActiveScribe.audioClips || []).some(clip => clip.id === clipId)
    );
  });

  // 4. Remove any empty layers
  newActiveScribe.audioLayers = (newActiveScribe.audioLayers || []).filter(
    layer => (layer.audioClipIds || []).length > 0
  );

  // 5. Update projectAudioLayerIds and scene audioLayerIds to only include existing layers
  const existingLayerIds = new Set(newActiveScribe.audioLayers.map(layer => layer.id));
  newActiveScribe.projectAudioLayerIds = (newActiveScribe.projectAudioLayerIds || []).filter(layerId =>
    existingLayerIds.has(layerId)
  );
  newActiveScribe.scenes.forEach(scene => {
    scene.audioLayerIds = (scene.audioLayerIds || []).filter(layerId => existingLayerIds.has(layerId));
  });

  return newActiveScribe;
}
